import React, { useRef, useState } from "react"
import { useTranslation } from "react-i18next"
import emailjs from "@emailjs/browser"
import { useSelector } from "react-redux"
import { Helmet } from "react-helmet"
// Data
import { EMAILJS_SERVICE, EMAILJS_USER, emailTemplates } from "../../data"
// Components
import Navbar from "../../components/Navbar/Navbar"
import Footer from "../../components/Footer/Footer"
import Button from "../../components/Button/Button"
import Map from "../../components/Map"
// Styles
import {
   Container,
   Wrapper,
   Title,
   Left,
   StyledForm,
   StyledInput,
   StyledTextArea,
   Message,
   MapWrapper,
   RegionNote,
   RegionText,
   RegionLogo,
} from "./Contact.styles"
import logoRegion from "../../images/region-bfc.jpg"

const Contact = () => {
   const { t } = useTranslation()
   const ref = useRef()

   const language = useSelector((state) => state.environment.language)
   const [success, setSuccess] = useState(null)
   const [message, setMessage] = useState(null)

   const handleSubmit = (e) => {
      e.preventDefault()
      emailjs
         .sendForm(
            EMAILJS_SERVICE,
            emailTemplates.find(
               (item) => item.name === "contactForm" && item.lang === language
            ).id,
            ref.current,
            EMAILJS_USER
         )
         .then(
            () => {
               setSuccess(true)
               setMessage(null)
            },
            (error) => {
               setSuccess(false)
               setMessage(error)
            }
         )
   }

   return (
      <>
         <Helmet>
            <title>{t("contactPage.meta.meta_title")}</title>
            <meta name="robots" content="noindex, nofollow" />
         </Helmet>
         <Container>
            <Navbar />
            <Wrapper>
               <Left>
                  <StyledForm ref={ref} onSubmit={handleSubmit}>
                     <Title>{t("contactPage.title.t1")}</Title>
                     <StyledInput
                        type="text"
                        placeholder={t("contactPage.placeholder.p1")}
                        name="name"
                     />
                     <StyledInput
                        type="text"
                        placeholder={t("contactPage.placeholder.p2")}
                        name="email"
                     />
                     <StyledTextArea
                        rows={10}
                        placeholder={t("contactPage.placeholder.p3")}
                        name="message"
                     />
                     <Button submit text={t("contactPage.button.b1")} />
                     {success && !message ? (
                        t("contactPage.message.m1")
                     ) : (
                        <Message>{message}</Message>
                     )}
                  </StyledForm>
                  <RegionNote>
                     <RegionText>{t("contactPage.text.t1")}</RegionText>
                     <RegionLogo src={logoRegion} />
                  </RegionNote>
               </Left>
               <MapWrapper>
                  <Map />
               </MapWrapper>
            </Wrapper>
            <Footer />
         </Container>
      </>
   )
}

export default Contact
